import { render } from "./VerticalNav.vue?vue&type=template&id=6b8b193b&scoped=true"
import script from "./VerticalNav.vue?vue&type=script&lang=js"
export * from "./VerticalNav.vue?vue&type=script&lang=js"

import "./VerticalNav.vue?vue&type=style&index=0&id=6b8b193b&lang=scss&scoped=true"

import exportComponent from "/var/www/appp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8b193b"]])

export default __exports__